import React from 'react'
import PropTypes from 'prop-types'
import MuiTextFieldWrapper from '../common/MuiTextField'
import './index.scss'

/**
 * A fully controlled, dumb autocomplete component for media
 * @param {Object} props The props
 * @param {String} props.label The label
 * @param {String} props.name The name
 * @param {String} props.value The input value
 * @param {Function} props.onChange Input change handler
 * @param {Array} props.suggestions Array of suggestion objects { contentId, mediaId }
 * @param {Function} props.onSuggestionSelect Handler for suggestion selection
 * @param {String} [props.placeholder] Placeholder text
 * @param {Boolean} [props.disabled] Disabled state
 */
function MediaAutoComplete (props) {
  const {
    label,
    name,
    value = '',
    onChange,
    suggestions = [],
    onSuggestionSelect,
    placeholder,
    disabled,
  } = props
  return (
    <div className="media-auto-complete">
      <MuiTextFieldWrapper
        className="media-auto-complete__input"
        label={label}
        name={name}
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        disabled={disabled}
      />
      {suggestions.length > 0 && (
        <ul className="media-auto-complete__list">
          {suggestions.map((record) => (
            <li
              onClick={() =>
                onSuggestionSelect &&
                onSuggestionSelect({ target: { name, value: record.contentId } }, record)
              }
              className="media-auto-complete__list-item"
              key={`media-auto-complete-suggestion-${record.mediaId}`}
            >
              {record.contentId}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

MediaAutoComplete.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  suggestions: PropTypes.array,
  onSuggestionSelect: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

MediaAutoComplete.defaultProps = {
  label: 'Media Content Id',
  value: '',
  suggestions: [],
  disabled: false,
}

export default MediaAutoComplete
